import Vue from 'vue'
export default {
  onAppLaunch(vm) {
    Vue.prototype.$bannerSelector = ({ applyCallback, closeCallback = null, usedList = [] }) => {
      vm.$targetSelector.active(vm, {
        title: vm.i18n('module.banner'),
        bodySlot: () => import('modules/banner/selector/bannerList.vue'),
        max: 1,
        applyCallback,
        closeCallback,
        usedList,
      })
    }
  },
}